import { inject } from '@angular/core';
import { signalStoreFeature, withProps } from '@ngrx/signals';
import { ENVIRONMENT } from 'environments';

export function withEnvironment() {
  return signalStoreFeature(
    withProps(() => ({
      environment: inject(ENVIRONMENT),
    })),
  );
}